// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__wmqBS","views":"styles_views__2Xev5","image":"styles_image__sb5lC","titleRow":"styles_titleRow__cFNRM","info":"styles_info__EGyRA"};